import request from '@/common/js/request'

/**
 * env 获取
 */
export const envGet = (option = {}) => {
    return request({
        url: '/node-apis/env',
        method: 'get',
        ...option
    })
}